<div class="login-form flex flex-col lg:flex-row min-h-screen">
    <div class="lg:w-7/12 w-full flex flex-col items-center justify-center bg-gray-100 p-6 leftSide">
        <div class="left-logo-screen">
            <div class="mb-4">
                <img src="assets/logo2.png" class="h-16" alt="Logo" />
            </div>
            <div class="mb-4">
                <img src="assets/tina2.png" class=" h-52 md:h-96" alt="Tina" />
            </div>
            <div class="text-center">
                <h2 class="text-2xl font-bold heading">Welcome To Gravitas AI</h2>
                <p class="text-lg italic text-gray-600 subheading">" Designing Tomorrow With Conversational AI "</p>
            </div>
        </div>
    </div>
    <div class="lg:w-5/12 w-full flex flex-col items-center justify-center p-6 rightSide">
        <form class="middleContainer" [formGroup]="form" novalidate>
            <div class="inputdiv">
                <div class="login-text">Forgot Password</div>
                <div>
                    <div for="over_label" style="margin-bottom: 10px;" class="text-[#000] lg:text-[#fff]">Email Address
                    </div>
                    <p-iconfield>
                        <input pInputText id="on_label" formControlName="email" name="email" fullWidth pSize="large"
                            class="input-text w-full"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formError['email'].errors}"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" autocomplete="on" />
                        <!-- <p-inputicon class="pi pi-user" style="margin-right: 10px;" /> -->

                    </p-iconfield>

                    <div class="mt-3 ml-2" *ngIf="linksend">
                        <small id="username-help" style="margin-top: -24px; color: #AFAFAF;">
                            Link has been sent to your Email ID
                        </small>
                    </div>


                    <small id="username-help" class="mtErr"
                        *ngIf="submitted && formError['email'].errors &&formError['email'].errors['required']">
                        Email is required
                    </small>

                    <small id="username-help" class="mtErr"
                        *ngIf="submitted && formError['email'].errors &&formError['email'].errors['pattern']">
                        Invalid Email</small>
                </div>
            </div>



            <div class="w-full">
                <button class="w-full login-button" [disabled]="isLoading" type="button" (click)="onSubmit()">
                    <i class="pi" [ngClass]="{
                    'pi-spin pi-spinner': isLoading,
                    'pi-sign-in': !isLoading
                  }" style="margin-right: 7px;"></i>
                    {{ buttonTitle }}
                </button>
                <!-- <button class="login-button" style="margin-top: 25px;">Login</button> -->
            </div>

            <div class="forgetpass" (click)="login()">
                Back to login
            </div>
        </form>


    </div>
</div>
<p-toast></p-toast>